import { defineNuxtPlugin } from '#app'
import { createAuth0 } from '@auth0/auth0-vue';

export default defineNuxtPlugin((_nuxtApp) => {
    console.log('modules/nuxtAuth/runtime/createAuthApp.ts');

    const config = useRuntimeConfig();
    const auth0Issuer = config.public.auth0Issuer as string;
    const auth0ClientId = config.public.auth0ClientId as string;
    const auth0RedirectUri = config.public.auth0RedirectUri as string;
    const auth0Audience = config.public.auth0Audience as string;

    const auth0Plugin = createAuth0({
        domain: auth0Issuer,
        clientId: auth0ClientId,
        authorizationParams: {
            redirect_uri: window.location.origin,
            audience: auth0Audience,
        },
        cacheLocation: 'localstorage',
    });

    _nuxtApp.vueApp.use(auth0Plugin);

})
